<template>
  <div id="main">
    <navigation v-once />
    <div class="container"></div>
    <div class="feedback-container">
      <h1>问题反馈</h1>
      <div class="feedback-form">
        <el-input
          type="textarea"
          v-model="feedbackForm.content"
          placeholder="请输入您的问题或建议"
          :rows="6"
        />
        <el-input
          v-model="feedbackForm.contact"
          placeholder="请输入您的邮箱或电话（可选）"
          style="margin: 20px 0"
        />
        <el-button type="primary" @click="submitFeedback" :loading="loading">提交反馈</el-button>
        <div v-if="loading" class="loading">提交中...</div>
        <div v-else-if="error" class="error">{{ error }}</div>
        <div v-else-if="success" class="success">反馈提交成功！感谢您的反馈！</div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue';
import { ElMessage } from 'element-plus';
import axios from 'axios';

export default defineComponent({
  setup() {
    const feedbackForm = ref({
      content: '',
      contact: ''
    });
    const loading = ref(false);
    const error = ref(null);
    const success = ref(false);

    const submitFeedback = async () => {
      if (!feedbackForm.value.content.trim()) {
        error.value = '反馈内容不能为空';
        ElMessage.error('反馈内容不能为空');
        return;
      }
      try {
        loading.value = true;
        error.value = null;
        success.value = false;
        
        // 从 localStorage 获取 Token（假设登录时存为 'token'）
        const token = localStorage.getItem('token'); // 或 sessionStorage，根据您的登录逻辑
        
        const response = await axios.post(
          'https://a.410121.xyz/api/feedback',  // 注意：统一用 /api/feedback（后端路由是 /api/feedback）
          {
            content: feedbackForm.value.content,
            contact: feedbackForm.value.contact
          },
          { 
            timeout: 5000,
            headers: {
              'Authorization': token ? `Bearer ${token}` : undefined  // 只在有 Token 时添加
            }
          }
        );
        
        if (response.data.code === 200) {
          ElMessage.success('反馈提交成功！');
          success.value = true;
          feedbackForm.value.content = '';
          feedbackForm.value.contact = '';
        } else {
          throw new Error(response.data.message || '提交失败');
        }
      } catch (err) {
        let message = err.message || '网络错误';
        if (err.response) {
          message = err.response.data?.message || `服务器错误 (${err.response.status})`;
        } else if (err.code === 'ECONNABORTED') {
          message = '请求超时，请检查网络或服务器状态';
        }
        error.value = message;
        ElMessage.error(`提交失败: ${message}`);
      } finally {
        loading.value = false;
      }
    };

    return {
      feedbackForm,
      loading,
      error,
      success,
      submitFeedback
    };
  }
});
</script>

<style scoped>
.container {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  margin-left: 0rem;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: -1;
  background-image: url(../assets/2.jpg);
  filter: blur(6px);
  will-change: transform;
}
.feedback-container {
  max-width: 800px;
  width: 90%;
  margin: 0 auto;
  padding: 20px;
  background: rgba(255, 255, 255, 0.8); /* 提高文字可读性 */
}
.feedback-form {
  margin-top: 20px;
}
.loading {
  color: #409eff;
  margin-top: 10px;
}
.error {
  color: #f56c6c;
  margin-top: 10px;
}
.success {
  color: #67c23a;
  margin-top: 10px;
}
</style>